import React, { useState, useEffect } from 'react';
import axios from 'axios';
import API_BASE_URL from '../../components/apiconfig/api-config';
import { useNavigate } from 'react-router-dom';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import backgroundImage1 from '../../assets/ship-2.jpg';
import backgroundImage2 from '../../assets/warehouse.jpg';
import backgroundImage3 from '../../assets/ship.jpg';

const Login = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();
  const [displayedText, setDisplayedText] = useState('');
  const [isTypingForward, setIsTypingForward] = useState(true);
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const companyName = "Import Management System";

  // Array of background images
  const backgroundImages = [
    backgroundImage1,
    backgroundImage2,
    backgroundImage3
  ];

  // Typing animation effect
  useEffect(() => {
    const typingInterval = setInterval(() => {
      if (isTypingForward) {
        // Typing forward
        if (displayedText.length < companyName.length) {
          setDisplayedText(companyName.substring(0, displayedText.length + 1));
        } else {
          // Switch to backward after a pause
          setTimeout(() => setIsTypingForward(false), 1000);
        }
      } else {
        // Erasing backward
        if (displayedText.length > 0) {
          setDisplayedText(companyName.substring(0, displayedText.length - 1));
        } else {
          // Switch to forward after a pause
          setTimeout(() => setIsTypingForward(true), 500);
        }
      }
    }, 100); // Typing/erasing speed

    return () => clearInterval(typingInterval);
  }, [displayedText, isTypingForward]);

  // Image slideshow effect
    useEffect(() => {
      const interval = setInterval(() => {
        setCurrentImageIndex((prevIndex) => 
          prevIndex === backgroundImages.length - 1 ? 0 : prevIndex + 1
        );
      }, 5000); // Change image every 5 seconds

      return () => clearInterval(interval);
    }, [backgroundImages.length]); // Added the missing dependency

  const handleLogin = async (e) => {
    e.preventDefault();
    setIsLoading(true);

    try {
      await axios.post(
        `${API_BASE_URL}/api/auth/login`,
        { email, password },
        { withCredentials: true }
      );
      toast.success('Login successful!', {
        position: 'top-right',
        autoClose: 2000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: 'colored',
      });

      // Clear any stale auto-logout deadline from previous sessions
      try {
        localStorage.removeItem('auto_logout_deadline');
      } catch (e) {
        console.error('Error clearing stale deadline:', e);
      }
      setTimeout(() => {
        navigate('/dashboard');
      }, 1200);
    } catch (err) {
      const msg =
        err.response?.data?.error ||
        err.message ||
        'Login failed. Please try again.';
      toast.error(msg, {
        position: 'top-right',
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: 'colored',
      });
      setIsLoading(false);
    }
  };

  return (                                                                                                                                                                                                  
    <>
      <ToastContainer 
        toastClassName={() =>
          'relative flex items-center p-4 min-h-12 rounded-xl justify-between overflow-hidden cursor-pointer bg-[#2691cc]/90 text-white text-base font-semibold shadow-lg backdrop-blur-sm border border-[#2d9cdb]/30'
        }
      />
      <div className="min-h-screen flex bg-white">
        {/* Left Side - Branding with Background Image Slideshow */}
        <div 
          className="hidden md:flex flex-col justify-between  items-center w-1/2 p-8 relative overflow-hidden"
        >
          {/* Slideshow background */}
          <div className="absolute inset-0 transition-opacity duration-1000 ease-in-out">
            {backgroundImages.map((image, index) => (
              <div 
                key={index}
                className={`absolute inset-0 bg-cover bg-center transition-opacity duration-1000 ${index === currentImageIndex ? 'opacity-100' : 'opacity-0'}`}
                style={{ backgroundImage: `url(${image})` }}
              />
            ))}
          </div>
          
          {/* Overlay content */}
          <div className="relative z-10 w-full h-full flex flex-col justify-between">
            {/* Company Name at Top with Typing Animation */}
          

            {/* Empty middle space */}
            <div></div>

            {/* Description at Bottom */}
            <div className="bg-black/30 p-2 rounded-xl backdrop-blur-sm w-full">
              <p className="text-lg text-white">
              <h1 className="text-2xl font-bold text-white min-h-[60px]">
                {displayedText}
                <span className="animate-pulse">|</span> {/* Cursor effect */}
              </h1>
              </p>
            </div>
          </div>  
        </div>

       {/* Right Side - Login Form */}
<div className="flex flex-col justify-center items-center w-full md:w-1/2 px-6 py-10 md:px-12 bg-white shadow-lg ">
  <div className="w-full max-w-md space-y-8">
    {/* Welcome Text */}
    <div className="text-center md:text-left">
      <h2 className="text-4xl font-extrabold text-gray-800">Welcome to <span className="text-[#2691cc]">IMS</span></h2>
      <p className="text-gray-600 mt-2 text-sm">Please enter your login credentials to continue</p>
    </div>

    {/* Form Start */}
    <form onSubmit={handleLogin} className="space-y-6">
      {/* Email Input */}
      <div>
        <label className="block text-sm font-medium text-gray-700 mb-1" htmlFor="email">Email or Username</label>
        <input
          id="email"
          type="email"
          autoFocus
          className="w-full px-4 py-3 border border-gray-300  focus:outline-none focus:ring-2 focus:ring-[#2691cc] focus:border-transparent transition-shadow"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          placeholder="Enter your email"
          required
        />
      </div>

      {/* Password Input */}
      <div>
        <label className="block text-sm font-medium text-gray-700 mb-1" htmlFor="password">Password</label>
        <input
          id="password"
          type="password"
          className="w-full px-4 py-3 border border-gray-300  focus:outline-none focus:ring-2 focus:ring-[#2691cc] focus:border-transparent transition-shadow"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          placeholder="Enter your password"
          required
        />
      </div>

      {/* Submit Button */}
      <button
        type="submit"
        disabled={isLoading}
        className={`w-full py-3 px-4 text-white font-semibold ${
          isLoading ? 'bg-[#2691cc] opacity-80 cursor-not-allowed' : 'bg-[#2691cc] hover:bg-[#2d9cdb]'
        } transition-all duration-200 flex items-center justify-center shadow-md`}
      >
        {isLoading ? (
          <>
            <svg className="animate-spin -ml-1 mr-2 h-4 w-4 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
              <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
              <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
            </svg>
            Signing in...
          </>
        ) : 'Sign in'}
      </button>
    </form>
    {/* End Form */}
  </div>
</div>

      </div>
    </>
  );
};

export default Login;